// extracted by mini-css-extract-plugin
export default {"highlightCard":"jXnyh","carouselWrapper":"YdnI6","carouselViewport":"rX3A5","carouselViewportStatic":"pRPvN","carouselContainer":"lAPe0","carouselSlide":"WMZp0","dots":"EE4PX"};